var EMBEDDED_TYPE = {
  EMBEDDED_IFRAME: 'EMBEDDED_IFRAME',
  NOT_EMBEDDED: 'NOT_EMBEDDED'
};
export { EMBEDDED_TYPE };